/*
 * Returns a boolean if the string matches the 'MM/DD/YYYY' regex
 * @param {String} the date string
 * @return {Boolean} the match
 */
var validDate = function validDate(date) {
  var re = /^((((0[13578])|([13578])|(1[02]))[/](([1-9])|([0-2][0-9])|(3[01])))|(((0[469])|([469])|(11))[/](([1-9])|([0-2][0-9])|(30)))|((2|02)[/](([1-9])|([0-2][0-9]))))[/]\d{4}$|^\d{4}$/; // eslint-disable-line max-len

  return re.test(date);
};

export default validDate;